import TablePagination from "@mui/material/TablePagination";
import { rowsPerPageOptions } from "../../../constants";

interface PaginationProps {
  count: number;
  page: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  rowsPerPage: number;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Pagination = ({
  count,
  page,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
}: PaginationProps) => {
  return (
    <div
      className="card-footer bg-white border-0 d-flex justify-content-between flex-wrap gap-2"
      style={{ padding: "16px" }}
    >
      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        sx={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          "& .MuiTablePagination-toolbar": {
            flexWrap: "wrap",
            rowGap: "8px",
          },
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              margin: 0,
            },
          "& .MuiTablePagination-actions": {
            marginLeft: "8px",
          },
        }}
      />
    </div>
  );
};

export default Pagination;
